module.exports = __webpack_public_path__ + "img/Benef 5.c75a584b.png";